import { useEffect, useState } from 'react'
import Loading from '../../components/Loading';
import { formatMoney } from '../../utils'

const PAYMENT_METHOD_ORDER = ['PIX', 'creditCard', 'paypal', 'manual'];

function paymentMethodSortKey(forma) {
  const idx = PAYMENT_METHOD_ORDER.indexOf(forma);
  return idx === -1 ? PAYMENT_METHOD_ORDER.length : idx;
}

function sortedPaymentMethodEntries(paymentMethods) {
  return Object.entries(paymentMethods || {}).sort(([a], [b]) => {
    const diff = paymentMethodSortKey(a) - paymentMethodSortKey(b);
    return diff !== 0 ? diff : a.localeCompare(b);
  });
}

function PaymentMethodIcon({ forma }) {
  if (forma === 'PIX') {
    return <span className="icon pix">PIX</span>;
  }
  if (forma === 'creditCard') {
    return <i className="icon fas fa-credit-card" aria-hidden="true"></i>;
  }
  if (forma === 'paypal') {
    return <i className="icon fab fa-paypal" aria-hidden="true"></i>;
  }
  if (forma === 'manual') {
    return <i className="icon fas fa-store" aria-hidden="true"></i>;
  }
  return <span className="icon payment-method-code">{forma}</span>;
}

export default function PaymentsReports({ reports, handleFind, clearReports, loading }) {
  const [initial, setInitial] = useState("")
  const [final, setFinal] = useState("")

  useEffect(() => {
    clearReports();
  }, []);

  return (
    <div className="report-section">
      <h3>Faturamento</h3>
      <h2>Listagem dos pedidos com <span>Pagamentos Aprovados.</span></h2>
      <div className="report-search">
        <div className="input-search">
          <label>Do dia</label>
          <input type="date" min="2021-04-23" name="date" autoComplete="new-password" placeholder="Do dia" onChange={(e) => setInitial(e.target.value)} />
        </div>
        <div className="input-search">
          <label>Ao dia</label>
          <input type="date" name="date" autoComplete="new-password" placeholder="Ao dia" onChange={(e) => setFinal(e.target.value)} />
        </div>
        <button onClick={() => handleFind({ initial, final })}>Gerar Relatório</button>
      </div>
      
      { loading ? <Loading /> : (reports && (
          <div className="report-details">
            <div className="totalAmount">
              <label>Faturamento</label>
              <span>{formatMoney(reports.total)}</span>
            </div>
            <div className="paymentMethods">
              {sortedPaymentMethodEntries(reports.paymentMethods).map(([forma, stats]) => (
                <div className="item" key={forma}>
                  <PaymentMethodIcon forma={forma} />
                  <label>{stats.total} {stats.total === 1 ? 'venda' : 'vendas'}</label>
                  <span>{formatMoney(stats.totalAmount)}</span>
                </div>
              ))}
          </div>
        </div>
      )) }
    </div>
  )
}